module.exports = __webpack_public_path__ + "img/history.83ad4900.svg";